import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Home , LogoutRounded} from "@mui/icons-material";
import {FaFirstOrder} from 'react-icons/fa';

import { IsSmallScreen } from "../../commonFunctions/CommonFunctions";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import WSBottomNav from "../AppBar/WSAppBar";

const DashboardLayout: React.FC = () => {
  // Define color variables
  const primaryColor = "#3D52A0";
  const secondaryColor = "#516F90";
  const hoverColor = "#23255a";
  const iconColor = "#4a4b77";
  const textColor = "#000";
  const hoverTextColor = "#fff";
  const backgroundColor = "#fff";
  const selectedBackgroundColor = "#7091E6";
  const boxShadowColor = "rgba(209, 200, 200, 0.6)";

  const isMobile = IsSmallScreen();

  const [open, setOpen] = useState(!isMobile);
  const [collapse, setCollapse] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleProfileMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

   

  const myNavItems = [
    { path: "/home", icon: <Home />, label: "Home" },
    { path: "/new-walk-in-order", icon: <FaFirstOrder />, label: "Orders" },
    // { path: "/contacts/list", icon: <LogoutRounded />, label: "Contact" }
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh", }}>

      {!isMobile && <Navbar
        anchorEl={anchorEl}
        handleCollapse={handleCollapse}
        collapse={collapse}
      />}

      <Sidebar
        collapse={collapse}
        handleCollapse={handleCollapse}
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        // bellow for color changes
        backgroundColor={backgroundColor}
        boxShadowColor={boxShadowColor}
        hoverColor={hoverColor}
        hoverTextColor={hoverTextColor}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        selectedBackgroundColor={selectedBackgroundColor}
        textColor={textColor}
        iconColor={iconColor}
      />

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          marginTop: !isMobile ? "5rem" : "0.7rem", // Offset for AppBar height
          overflowY: "auto", // Enable scrolling for content only
          marginLeft: isMobile ? "1rem" : collapse ? "7rem" : "18.6rem",
          marginRight: isMobile ? "1rem" : collapse ? "3rem" : "3rem",
        }}
      >
        <Outlet  />
      </Box>

      {isMobile && <WSBottomNav navigationItems={myNavItems} />}
    </Box>
  );
};

export default DashboardLayout;
